/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-plusplus */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Footer from '../components/Footer';
import DottedLine from '../assets/about/dottedLine.svg';
import Mail from '../assets/about/mail.svg';
import Insta from '../assets/about/insta.svg';
import Phone from '../assets/about/phone.svg';
import { speak, beelineText, openModal } from '../actions';
import Phases from '../assets/about/phases.svg';
import Potentia from '../assets/about/potentia.svg';
import Nicole from '../assets/about/nicole.png';
import Lisa from '../assets/about/lisa.png';

class About extends Component {
  constructor() {
    super();
    this.state = {
      firstname: '',
      lastname: '',
      email: '',
      check1: false,
      check2: false,
      check3: false,
      check4: false,
      message: '',
      firstnameError: false,
      lastnameError: false,
      emailError: false,
      messageError: false,
      checkError: false,
      nicoleModalOpen: false,
      lisaModalOpen: false,
    };
  }

  componentDidMount() {
    this.props.beelineText();
  }

  componentDidUpdate() {
    this.props.beelineText();
  }

  sendEmail = () => {
    this.setState((prevState) => {
      return {
        firstnameError: prevState.firstname === '',
        lastnameError: prevState.lastname === '',
        emailError: !(/\S+@\S+\.\S+/.test(prevState.email)),
        messageError: prevState.message === '',
        checkError: !prevState.check1 && !prevState.check2 && !prevState.check3 && !prevState.check4,
      };
    }, () => {
      if (
        !this.state.firstnameError
        && !this.state.lastnameError
        && !this.state.emailError
        && !this.state.messageError
        && !this.state.checkError
      ) {
        let sub = '';

        if (this.state.check1) {
          sub += '\t\tLearn more about webinars, professional development & 1-1 consultations \n';
        }

        if (this.state.check2) {
          sub += '\t\tBecoming a corporate or college partner\n';
        }

        if (this.state.check3) {
          sub += '\t\tI want to stay in touch and receive videos, blog posts, and more info!\n';
        }

        if (this.state.check4) {
          sub += '\t\tOther\n';
        }

        let body = `
          -----The below message was auto-generated by the Contact Us form on the My Brain Explained site-----\n\n
          First name: ${this.state.firstname}\n\n
          Last name: ${this.state.lastname}\n\n 
          Email: ${this.state.email}\n\n
          What are you interested in?\n${sub}\n
          Custom Message:\n
          ${this.state.message}
        `;
        body = encodeURIComponent(body);
        window.location.href = `mailto:information@potentiainstitute21.org?cc=${this.state.email}&body=${body}&subject=MBE Question`;
      }
    });
  }

  handleCheck = (x) => {
    const y = `check${x}`;
    this.setState((prevState) => { return { [y]: !prevState[y] }; });
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }

  renderBlurb = (who = 'nicole') => {
    return (
      <div className="about-bottom-tile" onMouseEnter={() => { this.setState((prevState) => (who === 'nicole' ? { nicoleModalOpen: true } : { lisaModalOpen: true })); }}>
        <img src={who === 'nicole' ? Nicole : Lisa} className="about-profile-pic" alt="person" />
        <div className="about-tile-blurb about-shadow">
          <h4>{who === 'nicole' ? 'Nicole Ofiesh' : 'Lisa Poller'}</h4>
          <p>{who === 'nicole' ? 'Ph.D. Co-Founder, Chief Innovation Officer' : 'Co-Founder, Chief Strategy Officer'}</p>
        </div>
      </div>
    );
  }

  renderTile = (who = 'nicole') => {
    return (
      <div className="about-bottom-tile about-shadow" onMouseLeave={() => { this.setState((prevState) => (who === 'nicole' ? { nicoleModalOpen: false } : { lisaModalOpen: false })); }}>
        <div className="about-tile-blurb">
          <div className="about-tile-subheader-container">
            <h4 className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>{who === 'nicole' ? 'Nicole Ofiesh' : 'Lisa Poller'}</h4>
            <div className="about-x-icon" />
          </div>
          <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>{who === 'nicole' ? 'Ph.D. Co-Founder, Chief Innovation Officer' : 'Co-Founder, Chief Strategy Officer'}</p>
        </div>
        <div className="about-tile-bio">
          {who === 'nicole' ? <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}> Nicole Ofiesh, Ph.D. is a <b>cognitive behavioral scientist</b> with expertise in the intersection of learning and adulthood. She applies this knowledge with an understanding of context and culture to explain how people learn as individuals. She has been in hundreds of classrooms and corporations over the years teaching and mentoring teachers, administrators and professionals from line workers to medical doctors.</p> : <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}> Lisa is an <b>entrepreneurial and strategic education innovation leader</b> with over 30 years of experience transforming organizational impact,  Lisa has been involved in technology innovation for more than two decades including work in education technology and growth tracking venture capital-backed start-ups in a variety of fields.</p>}
        </div>
        <div className="about-mail-container">
          <img src={Mail} alt="mail" />
          <a className={`color ${this.props.speechEnabled && 'bolded'}`} href={`mailto: ${who === 'nicole' ? 'OfficerNicole@potentiainstitute21.org' : 'lpoller@potentiainstitute21.org'}`}>
            {who === 'nicole' ? 'OfficerNicole@potentiainstitute21.org' : 'lpoller@potentiainstitute21.org'}
          </a>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="about-background">
        <div className="about">
          <div className={`about-header ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>
            About Us
          </div>
          <img className="about-header-img" src={DottedLine} alt="dotted-line" />
          <div className={`about-subheader ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>
            Our Mission
          </div>
          <div className="about-content-container">
            <div className="about-content-row">
              <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}><b>Knowledge is power</b>. It enables us to find our right fit, strengthen areas where we have challenges, seek support, advocate for ourselves and design our own learning or work environment. Yet, Information about our brains has not been readily available to most people in a practical manner.</p>
            </div>
            <div className="about-content-row">
              <img src={Phases} alt="boy" />
              <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}><b>We don’t think that you should have to spend thousands of dollars</b> and hours of time to get a clinical assessment of your brain if what you really want to know is how to make the most of your time at school, work or even in your relationships. </p>
            </div>
            <div className="about-content-row">
              <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}><b>My Brain Explained is the first free tool</b> that applies the science of the brain in an immediate, practical and useful way for improving your performance. With this information, you can supercharge your performance, tackle your goals for <b>school or work</b>, and improve communication in your relationships.</p>
            </div>
          </div>
          <div className={`about-subheader ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>
            What Is My Brain Explained
          </div>
          <div className="about-content-container">
            <div className="about-content-row">
              <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>With My Brain Explained you will have access to <b>surveys</b> that provide you with <b>secure and personalized results</b> based on aspects of cognition and learning critical to reaching your potential. It covers areas including:</p>
            </div>
            <div className="about-content-row">
              <div className="about-content-bubble-container">
                <div className={`about-content-bubble ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>Organization</div>
                <div className={`about-content-bubble ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>Planning</div>
                <div className={`about-content-bubble ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>Your World View</div>
                <div className={`about-content-bubble ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>Productivity</div>
                <div className={`about-content-bubble ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>Writing</div>
                <div className={`about-content-bubble ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>Communication</div>
                <div className={`about-content-bubble ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>Problem Solving</div>
              </div>
            </div>
            <div className="about-content-row">
              <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>With results from your mini survey, you will get a <b>Toolkit</b> of personalized recommendations that enable you to <b>amplify your strengths</b> and help you understand how to <b>improve</b> selected areas of learning or work. </p>
            </div>
            <div className="about-content-row">
              <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>These tools can be paired with <b>personalized</b> coaching that helps you incorporate these recommendations into your life.</p>
            </div>
          </div>
          <div className={`about-subheader ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>
            <img src={Potentia} alt="potentia" /> Potentia Institute 21
          </div>
          <div className="about-content-container">
            <div className="about-content-row">
              <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}><b>Products and services that give you personalized tools for school, work, and life.</b></p>
            </div>
            <div className="about-content-row">
              <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}>Founded in 2019, Potentia Institute 21 is a social impact enterprise dedicated to enhancing adult <b>Potential</b> in the <b>21st Century</b> through science of the brain.  All individuals should have the opportunity to <b>understand how they best learn</b> to enhance their learning in the workplace and in the classroom.</p>
            </div>
          </div>
          <div className="about-bottom-container">
            {this.state.nicoleModalOpen ? this.renderTile('nicole') : this.renderBlurb('nicole')}
            {this.state.lisaModalOpen ? this.renderTile('lisa') : this.renderBlurb('lisa')}
            <div className="about-bottom-tile">
              <div className="about-contact-container">
                <button type="button" className="about-potentia-button" onClick={(e) => { e.preventDefault(); window.location.href = 'https://www.potentiainstitute21.org/'; }}>Potentia 21 Website</button>
                <p className={`color ${this.props.speechEnabled && 'bolded'}`} onClick={this.props.speak}><b>Want to learn more</b> about the Potentia Institute 21 and our projects? Submit this form and we&apos;ll reach out to you soon!</p>
                <button type="button" className="about-contact-button" onClick={() => { this.props.openModal('Contact'); }}>Contact Us</button>
                <div className="contact-info">
                  <div className="contact-icons">
                    <img src={Mail} alt="mail" />
                    <a className={`icons-text color ${this.props.speechEnabled && 'bolded'}`} href="mailto: information@potentiainstitute21.org">
                      information@potentiainstitute21.org
                    </a>
                  </div>
                  <div className="contact-icons">
                    <img src={Phone} alt="phone" />
                    <div className={`icons-text color ${this.props.speechEnabled && 'bolded'}`} role="button" tabIndex={0} onClick={this.props.speak}>
                      650-393-9308
                    </div>
                  </div>
                  <div className="contact-icons">
                    <img src={Insta} alt="insta" />
                    <div className={`icons-text color ${this.props.speechEnabled && 'bolded'}`} role="button" tabIndex={0} onClick={this.props.speak}>
                      @potentia.institute21
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
const mapStateToProps = (state) => (
  { speechEnabled: state.speech.enabled }
);
export default connect(mapStateToProps, { speak, beelineText, openModal })(About);
